//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 25/06/2025
// Version : 1
// Description : Pantalla principal de estadisticas de stock de envases o recuentofisico
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useState, useEffect,useRef } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  MenuItem,
  Autocomplete,
  IconButton,
  Chip,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Navbar from "../../Navbar";
import dayjs from "dayjs";
import "dayjs/locale/es";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { UrlApi } from "../../../services/apirest";
import { Card, CardContent, CardHeader } from "@mui/material";
import { LineChart } from "@mui/x-charts/LineChart";
import { Snackbar, Alert } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function EstadisticaStockEnvases(props) {
  dayjs.locale("es");
  dayjs.extend(customParseFormat);
  const [datosStock, setDatosStock] = useState([]);
  const [fechaDesde, setFechaDesde] = useState(dayjs().startOf("month"));
  const [fechaHasta, setFechaHasta] = useState(dayjs().endOf("month"));

  const [errorFechaDesde, setErrorFechaDesde] = useState(false);
  const [errorFechaHasta, setErrorFechaHasta] = useState(false);
  const [mensajeErrorFechaDesde, setMensajeErrorFechaDesde] = useState("");
  const [mensajeErrorFechaHasta, setMensajeErrorFechaHasta] = useState("");

  const [segmentos, setSegmentos] = useState([]);
  const [productos, setProductos] = useState([]);

  const [openSnack, setOpenSnack] = useState(false);
  const [mensajeSnack, setMensajeSnack] = useState("");
  const [severitySnack, setSeveritySnack] = useState("error");

  // sucursales
  const [sucursalesDisponibles, setSucursalesDisponibles] = useState([]);
  const [sucursalesSeleccionadas, setSucursalesSeleccionadas] = useState([]);

  // Fetch general
  const obtenerSucursales = () => {
    fetch(UrlApi + "/sucursales")
      .then((res) => res.json())
      .then((data) => setSucursalesDisponibles(data));
  };

  // Fetch para Granel
  const obtenerSucursales2 = () => {
    fetch(UrlApi + "/sucursales/tipoPlanta")
      .then((res) => res.json())
      .then((data) => setSucursalesDisponibles(data)); //actualiza el mismo estado
  };

  // useEffect dependiente de segmentos
  useEffect(() => {
    if (segmentos.includes("Granel") && !segmentos.includes("Envasado")) {
      obtenerSucursales2(); // solo granel → tipo planta
    } else {
      obtenerSucursales(); // envasado o ambos → todas las sucursales
    }

    // limpiar la selección actual cuando cambia la fuente de sucursales
    setSucursalesSeleccionadas([]);
  }, [segmentos]);

  // console.log("SUC PLANTA",sucPlanta);

  const [busquedaRealizada, setBusquedaRealizada] = useState(false);

  // ----------- VALIDACION DE FECHAS PARA COMPLETAR -------------
  const validarFechas = (desde, hasta) => {
    let errorDesde = false;
    let errorHasta = false;
    let msgDesde = "";
    let msgHasta = "";

    if (desde && hasta && desde.isAfter(hasta)) {
      errorDesde = true;
      errorHasta = true;
      msgDesde = "La fecha Desde no puede ser mayor a la fecha Hasta";
      msgHasta = "La fecha Hasta no puede ser menor a la fecha Desde";
    }

    setErrorFechaDesde(errorDesde);
    setErrorFechaHasta(errorHasta);
    setMensajeErrorFechaDesde(msgDesde);
    setMensajeErrorFechaHasta(msgHasta);

    return !(errorDesde || errorHasta); // devuelve true si todo bien
  };

  //---------------- EL BOTON BUSCAR--------------
  const mostrarError = (mensaje) => {
    setMensajeSnack(mensaje);
    setSeveritySnack("error");
    setOpenSnack(true);
  };

  const handleBuscar = () => {
    if (!validarFechas(fechaDesde, fechaHasta)) {
      mostrarError("Por favor corrija las fechas antes de buscar.");
      return;
    }
    if (sucursalesSeleccionadas.length === 0) {
      mostrarError("Debe seleccionar al menos una sucursal.");
      return;
    }
    if (segmentos.length === 0) {
      mostrarError("Debe seleccionar al menos un segmento.");
      return;
    }
    if (productos.length === 0) {
      mostrarError("Debe seleccionar al menos un producto.");
      return;
    }

    const params = new URLSearchParams({
      fecha_desde: fechaDesde.format("YYYY-MM-DD"),
      fecha_hasta: fechaHasta.format("YYYY-MM-DD"),
      sucursales: sucursalesSeleccionadas.map((s) => s.id).join(","),
      segmentos: segmentos.join(","),
      productos: productos.join(","),
    });

    fetch(`${UrlApi}/estadisticaStockFisico?${params.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        //console.log("Datos recibidos:", data);
        setDatosStock(data);
        setBusquedaRealizada(true); // <<< marca que ya buscaron
      })
      .catch((err) => console.error(err));
  };

  //--------------------- PARA EL GRAFICO---------------------------
  const fechasUnicas = Array.from(
    new Set(datosStock.map((item) => dayjs(item.fecha).format("DD-MM-YYYY")))
  ).sort(
    (a, b) => dayjs(a, "DD-MM-YYYY").unix() - dayjs(b, "DD-MM-YYYY").unix()
  );

  // Agrupar por clave compuesta
  const seriesMap = {};

  datosStock.forEach((item) => {
    const fecha = dayjs(item.fecha).format("DD-MM-YYYY");
    const clave = `${item.sucursal_nombre} ${item.segmento} ${item.producto}`;

    if (!seriesMap[clave]) {
      seriesMap[clave] = {};
    }

    seriesMap[clave][fecha] = item.stock_toneladas;
  });

  // Función para generar colores aleatorios en formato hex
  const generarColorHex = () => {
    const letras = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letras[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  // Map para asegurar que cada clave tenga un color único
  const colorPorClave = useRef({});

  const series = Object.entries(seriesMap).map(([clave, valores]) => {
    if (!colorPorClave.current[clave]) {
      let nuevoColor;
      do {
        nuevoColor = generarColorHex();
      } while (Object.values(colorPorClave.current).includes(nuevoColor));
      colorPorClave.current[clave] = nuevoColor;
    }

    return {
      label: clave,
      data: fechasUnicas.map((f) => valores[f] ?? 0),
      color: colorPorClave.current[clave],
      valueFormatter: (value) => `${Number(value).toFixed(2)} T`,
    };
  });

  const customize = {
    legend: { hidden: true },
    margin: { top: 10 },
    height: 400,
  };

  const handleClose = () => {
    props.grafico(false);
  };

  return (
    <div>
      <Navbar />

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          border: "1px solid grey",
          borderRadius: 2,
          padding: "8px 16px",
          backgroundColor: "black",
          marginTop: 2,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            left: 0,
            color: "white",
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h5"
          component="div"
          color="white"
          sx={{ margin: "0 auto" }}
        >
          Estadística Recuento Físico
        </Typography>
      </Box>

      <Grid container padding={3} spacing={2}>
        {" "}
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
          <Grid item xs={12} sm={8} md={6} lg={4} xl={3}>
            <Card
              sx={{
                // padding: 2,
                backgroundColor: "#DEDEDE",
                boxShadow: 3,
                borderRadius: 2,
                width: "100%",
                border: "1px solid black",
              }}
            >
              <CardContent>
                {/* FECHAS */}
                <Box gap={2} display="flex" marginBottom={2}>
                  <DatePicker
                    label="Desde"
                    value={fechaDesde}
                    onChange={(newValue) => {
                      setFechaDesde(newValue);
                      validarFechas(newValue, fechaHasta);
                      setDatosStock([]);
                      setBusquedaRealizada(false); // <<< oculta resultado viejo
                    }}
                    inputFormat="DD-MM-YYYY"
                    slotProps={{
                      textField: {
                        size: "small",
                        error: errorFechaDesde,
                        helperText: mensajeErrorFechaDesde,
                        sx: {
                          width: 200,
                          backgroundColor: "white",
                          "& .MuiInputLabel-root": {
                            color: "black",
                          },
                          "& fieldset": {
                            borderColor: "black", // opcional: color del borde
                          },
                        },
                      },
                    }}
                  />

                  <DatePicker
                    label="Hasta"
                    value={fechaHasta}
                    onChange={(newValue) => {
                      setFechaHasta(newValue);
                      validarFechas(fechaDesde, newValue);
                      setDatosStock([]);
                      setBusquedaRealizada(false); // <<< oculta resultado viejo
                    }}
                    inputFormat="DD-MM-YYYY"
                    slotProps={{
                      textField: {
                        size: "small",
                        error: errorFechaHasta,
                        helperText: mensajeErrorFechaHasta,
                        sx: {
                          width: 200,
                          backgroundColor: "white",
                          "& .MuiInputLabel-root": {
                            color: "black",
                          },
                          "& fieldset": {
                            borderColor: "black", // opcional: color del borde
                          },
                        },
                      },
                    }}
                  />
                </Box>

                {/* SEGMENTO Y PRODUCTO */}
                <Box
                  display="flex"
                  gap={2}
                  justifyContent="center"
                  marginBottom={2}
                >
                  <TextField
                    select
                    label="Segmento"
                    size="small"
                    sx={{
                      width: 200,
                      backgroundColor: "white",
                      borderRadius: 2,

                      "& .MuiInputBase-root": {
                        padding: "1px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                      },
                      "& .MuiInputLabel-root": {
                        color: "black",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black",
                      },
                    }}
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                        </Box>
                      ),
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            backgroundColor: "#f5f5f5",
                          },
                        },
                      },
                    }}
                    value={segmentos}
                    onChange={(e) => {
                      setSegmentos(e.target.value);
                      setDatosStock([]);
                      setBusquedaRealizada(false); // <<< oculta resultado viejo
                    }}
                  >
                    <MenuItem value="Envasado">Envasado</MenuItem>
                    <MenuItem value="Granel">Granel</MenuItem>
                  </TextField>

                  <TextField
                    select
                    label="Producto"
                    size="small"
                    sx={{
                      width: 200,
                      backgroundColor: "white",
                      borderRadius: 2,

                      "& .MuiInputBase-root": {
                        padding: "1px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                      },
                      "& .MuiInputLabel-root": {
                        color: "black",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black",
                      },
                    }}
                    SelectProps={{
                      multiple: true,
                      renderValue: (selected) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                          {selected.map((value) => (
                            <Chip key={value} label={value} size="small" />
                          ))}
                        </Box>
                      ),
                      MenuProps: {
                        PaperProps: {
                          sx: {
                            maxHeight: 200,
                            backgroundColor: "#f5f5f5",
                          },
                        },
                      },
                    }}
                    value={productos}
                    onChange={(e) => {
                      setProductos(e.target.value);
                      setDatosStock([]);
                      setBusquedaRealizada(false); // <<< oculta resultado viejo
                    }}
                  >
                    <MenuItem value="Butano">Butano</MenuItem>
                    <MenuItem value="Propano">Propano</MenuItem>
                  </TextField>
                </Box>

                {/* SUCURSAL */}
                <Box marginBottom={2}>
                  <Autocomplete
                    multiple
                    size="small"
                    options={sucursalesDisponibles}
                    value={sucursalesSeleccionadas}
                    onChange={(event, value) => {
                      setSucursalesSeleccionadas(value);
                      setDatosStock([]); // limpia los datos del gráfico y leyenda
                      setBusquedaRealizada(false); // <<< oculta resultado viejo
                    }}
                    getOptionLabel={(option) =>
                      `${option.id} - ${option.nombre}`
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Sucursal"
                        placeholder="Tipee para buscar..."
                        //focused
                        sx={{
                          backgroundColor: "white",
                          width: "100%",
                          "& .MuiInputLabel-root": {
                            color: "black",
                          },
                          "& fieldset": {
                            borderColor: "black", // opcional: color del borde
                          },
                        }}
                      />
                    )}
                  />
                </Box>

                {/* BOTÓN */}
                <Box display="flex" justifyContent="center" marginTop={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleBuscar}
                    sx={{ height: 40 }}
                    disabled={errorFechaDesde || errorFechaHasta}
                  >
                    Generar Gráfico
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>

          {/* LEYENDA */}
          <Grid item xs={12} sm={6} md={6} lg={8} xl={9}>
            {series.length > 0 && (
              <Box
                sx={{
                  backgroundColor: "#DEDEDE",
                  border: "1px solid black",
                  borderRadius: 2,
                  padding: 2,
                  display: "grid",
                  // calculamos cuántas columnas necesita según la cantidad de ítems
                  gridTemplateColumns: `repeat(${Math.ceil(
                    series.length / 8
                  )}, 1fr)`,
                  columnGap: 2,
                  rowGap: 1,
                }}
              >
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{
                    gridColumn: `span ${Math.ceil(series.length / 8)}`, // título ocupa todas las columnas
                    color: "black",
                  }}
                >
                  Leyenda del gráfico
                </Typography>

                {series.map((serie, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        backgroundColor: serie.color,
                        marginRight: 1,
                        flexShrink: 0,
                      }}
                    />
                    <Typography variant="body2">{serie.label}</Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Grid>
        </LocalizationProvider>
        {/* LISTA SOLO PARA PROBAR QUE TRAE LOS DATOS */}
        {/* <Box padding={2}>
        {datosStock.length === 0 ? (
          <Typography>No hay resultados</Typography>
        ) : (
          <ul>
            {datosStock.map((item, index) => (
              <li key={index}>
                {item.sucursal_nombre} - {item.segmento} - {item.producto} -{" "}
                {item.stock_toneladas} toneladas (
                {dayjs(item.fecha).format("DD-MM-YYYY")})
              </li>
            ))}
          </ul>
        )}
      </Box> */}
        {/* GRAFICO */}
        {busquedaRealizada &&
          (datosStock.length > 0 ? (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1}>
              <LineChart
                xAxis={[{ data: fechasUnicas, scaleType: "point" }]}
                series={series}
                {...customize}
                sx={{ width: "100%" }}
              />
            </Grid>
          ) : (
            <Grid item xs={12} sm={8} md={6} lg={4} xl={3}>
              <Box
                sx={{
                  backgroundColor: "#DEDEDE",
                  border: "1px solid black",
                  borderRadius: 2,
                  padding: 2,
                  display: "flex", // Cambiado de "grid" a "flex"
                  justifyContent: "center",
                  alignItems: "center",
                  height: 50, // Altura mínima para centrar verticalmente
                  marginBottom: 10,
                }}
              >
                <Typography sx={{ color: "black", fontSize: 18 }}>
                  No hay resultados encontrados
                </Typography>
              </Box>
            </Grid>
          ))}
        <Grid item marginBottom={4}>
          <Button variant="contained" onClick={handleClose} color="error">
            Volver
          </Button>
        </Grid>
      </Grid>

      <Snackbar
        open={openSnack}
        autoHideDuration={4000}
        onClose={() => setOpenSnack(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={severitySnack} onClose={() => setOpenSnack(false)}>
          {mensajeSnack}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default EstadisticaStockEnvases;
